import {types} from './types';

const setGetCreditLimitsAction = (payload) => {
    return {
        type: types.SET_LIST_CREDIT,
        payload,
      }
}

const setGetListGroupsAction = (payload) => {
  return {
      type: types.SET_LIST_GROUPS,
      payload,
    }
}


const setGetCreditLiveAction = (payload) => {
  return {
      type: types.SET_CREDIT_LIVE,
      payload,
    }
}


export {
  setGetCreditLimitsAction,
  setGetListGroupsAction,
  setGetCreditLiveAction
}
